var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8008 3.67188V17.9219C15.8008 18.3361 15.465 18.6719 15.0508 18.6719H3.80078C3.38657 18.6719 3.05078 18.3361 3.05078 17.9219V3.67188",
    fill: "#D50000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8008 3.67188V17.9219C15.8008 18.3361 15.465 18.6719 15.0508 18.6719H3.80078C3.38657 18.6719 3.05078 18.3361 3.05078 17.9219V3.67188",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05078 3.67188V2.17188C6.05078 1.75766 6.38657 1.42188 6.80078 1.42188H12.0508C12.465 1.42188 12.8008 1.75766 12.8008 2.17188V3.67188",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.800781 3.67188H18.0508",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05078 6.29688V15.2969",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42578 6.29688V15.2969",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8008 6.29688V15.2969",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.fef21e752f89025c87d42a47ed98d96e.svg";
export { ForwardRef as ReactComponent };